import {ErrorCode} from 'react-dropzone';

export default {
  'notAvailable': 'N/D',
  'actionUpdatePosition': 'Atualizar posição',

  'maintenanceRegisteredTabTitle': 'Cadastradas',
  'maintenanceUpcomingTabTitle': 'Próximas',
  'maintenanceOngoingTabTitle': 'Andamento',
  'maintenanceCompletedTabTitle': 'Finalizadas',

  'maintenanceStatusPending': 'Pendente',
  'maintenanceStatusOngoing': 'Em Andamento',
  'maintenanceStatusCompleted': 'Finalizada',
  'maintenanceRealizeFormTitle': 'Manutenção Vinculada',

  'sharedSelectADate': 'Selecione uma data',
  'sharedTypeHere': 'Digite aqui...',
  'sharedEvery': 'A cada',
  'sharedHours': 'Horas',
  'sharedMonths': 'Meses',
  'sharedDay': 'Dia',
  'sharedCost': 'Custo',
  'sharedCurrent': 'Atual',
  'sharedNextF': 'Próxima',
  'sharedLatest': 'Última',
  'sharedVehicle': 'Veículo',
  'sharedOdometer': 'Odômetro',
  'sharedDate': 'Data',
  'sharedHourmeter': 'Horímetro',
  'sharedInterval': 'Intervalo',
  'sharedTitle': 'Título',
  'sharedKind': 'Tipo',
  'sharedPeriod': 'Período',
  'sharedAction': 'Ação',
  'sharedCreatedBy': 'Criado por',
  'sharedCreatorEmail': 'E-mail do Criador',
  'sharedCreatedAt': 'Data de Criação',
  'sharedUpdatedAt': 'Última Edição',
  'URL': 'URL',

  'sharedCreateNew': 'Cadastrar Nova',
  'sharedIdentification': 'Identificação',
  'sharedLoading': 'Carregando...',
  'sharedHide': 'Esconder',
  'sharedSave': 'Salvar',
  'sharedSet': 'Aplicar',
  'sharedCancel': 'Cancelar',
  'sharedSelect': 'Selecione',
  'sharedUntil': 'até',
  'sharedNoResultFound': 'Nenhum resultado encontrado!',
  'sharedResults': 'Resultados',
  'sharedBack': 'Voltar',
  'deviceAccessDenied': 'Este dispositivo não pertence à sua conta.',
  'deviceAccessDeniedBackToDashboard': 'Voltar ao Dashboard',
  'sharedAdd': 'Adicionar',
  'sharedEdit': 'Editar',
  'sharedRemove': 'Remover',
  'sharedConfirm': 'Confirmar',
  'sharedConfirmQuestion': 'Confirmar?',
  'sharedUpdate': 'Atualizar',
  'sharedConnect': 'Associar',
  'sharedRegister': 'Cadastro',
  'sharedOf': 'de',
  'sharedLogout': 'Sair',
  'sharedYes': 'Sim',
  'sharedNo': 'Não',
  'sharedLogin': 'Login',
  'sharedComment': 'Comentário',
  'sharedNext': 'Próximo',
  'sharedPrev': 'Anterior',
  'sharedAll': 'Todos',
  'sharedFirst': 'Primeiro',
  'sharedLast': 'Último',
  'sharedNoDataText': 'Não há dados para exibir',
  'sharedEditAttributeFrom': 'Editando atributo de {name}',
  'sharedCreateAttributeFrom': 'Criando atributo em {name}',
  'sharedRemoveMessage': 'Você está removendo',
  'sharedRemoveConfirmationMessage': 'Realmente deseja fazer isso?',
  'sharedRemoveConfirm': 'Remover item?',
  'sharedKm': 'Km',
  'sharedMi': 'Mi',
  'sharedNmi': 'Milhas Náuticas',
  'sharedKn': 'Kn',
  'sharedKmh': 'Km/h',
  'sharedMph': 'Mph',
  'sharedHour': 'Hora',
  'sharedMinute': 'Minuto',
  'sharedSecond': 'Segundo',
  'sharedDays': 'dias',
  'sharedHours': 'horas',
  'sharedMinutes': 'minutos',
  'sharedDecimalDegrees': 'Graus Decimais',
  'sharedDegreesDecimalMinutes': 'Graus Minutos Decimais',
  'sharedDegreesMinutesSeconds': 'Graus Minutos Segundos',
  'sharedIdentification': 'Identificação',
  'sharedTracker': 'Rastreador',
  'sharedName': 'Nome',
  'sharedDescription': 'Descrição',
  'sharedSearch': 'Busca',
  'searchMinLength': 'Digite ao menos {min} caracteres para pesquisar',
  'searchInputHint': 'Buscar (mín. {min})',
  'sharedSelectAColor': 'Selecione uma cor',
  'sharedFilters': 'Filtros',
  'sharedGeofence': 'Geocerca',
  'sharedGeofences': 'Geocercas',
  'fleetSearchPlaceholder': 'Pesquise para filtrar',
  'fleetFilterBy': 'Filtrar por:',
  'geofenceAllDevices': 'Todos os Dispositivos',
  'geofenceColor': 'Cor',
  'geofenceLineDistance': 'Distância da Linha (m)',
  'geofenceSpeedLimit': 'Limite de Velocidade (km/h)',
  'sharedSinister': 'Sinistro',
  'sharedSinisters': 'Sinistros',
  'sharedCompany': 'Central',
  'sharedMyCompany': 'Minha Central',
  'sharedCompanies': 'Centrais',
  'sharedCompanyConfiguration': 'Configuração da central',
  'sinisterOpen': 'Sinistro Aberto',
  'sinisterCreate': 'Abrir Sinistro',
  'sinisterOccurrenceDate': 'Data da Ocorrência',
  'sinisterOccurrenceShowMore': 'Exibir Mais',
  'sinisterNumber': 'Número',
  'sinisterTypeAttemptToTriggerPromptResponse': 'Tentativa de acionar a resposta imediata',
  'sinisterTypeLimitExceededInSearchConditions': 'Limite excedido nas condições de pesquisa',
  'sinisterTypePoliceArriveAtTheScene': 'A polícia chega ao Local',
  'sinisterTypePromptResponseActivated': 'Resppsta Ativada',
  'sinisterTypeRegisterThePoliceReport': 'Registrar O Relatório da Polícia',
  'sinisterTypeRequestedVehicleForVehicleRecovery': 'Veículo solicitado Para Recuperação de Veículos',
  'sinisterTypeSupportArrivesOnSite': 'Suporte chega ao local',
  'sinisterTypeSupportDoesOnSitePreservation': 'Suporte Faz Preservação no Local',
  'sinisterTypeSupportOnTheWay': 'Apoio No Caminho',
  'sinisterTypeSupportStartsPatrolling': 'Suporte Começa a patrulhar',
  'sinisterTypeUninstalledEquipmentFound': 'Equipamento desinstalado encontrado',
  'sinisterTypeUndefined': 'ERRO!',
  'sinisterTypeVehicleNotFound': 'Veículo Não Encontrado',
  'sinisterTypeVehicleFound': 'Veículo Encontrado',
  'sinisterTypeFalsePositive': 'Falso Positivo',
  'sinisterClosingDate': 'Data de Fechamento',
  'sinisterClosingType': 'Tipo de Fechamento',
  'sinisterVehicleDamaged': 'Veículo Danificado',
  'sinisterClosingAddress': 'Endereço de Fechamento',
  'sinisterClosingDescription': 'Descrição do Fechamento',
  'sinisterDevicePlate': 'Placa',
  'sinisterDeviceModel': 'Modelo',
  'sinisterSummary': 'Resumo do Sinistro',
  'sinisterDeviceColor': 'Cor',
  'sinisterMobile': 'Celular',
  'sinisterTypeLabel': 'Tipo de Sinistro',
  'sinisterClosingTitle': 'Fechamento',
  'sinisterCloseAction': 'Fechar Sinistro',
  'sinisterCloseError': 'Erro ao tentar Fechar o Sinistro',
  'sinisterTypeQuestion': 'Do que se trata o sinistro',
  'deviceShareError': 'Ops! Houve um erro ao compartilhar o dispositivo.',
  'sinisterOpeningDate': 'Data de Abertura',
  'sinisterStatus': 'Status',
  'sinisterActions': 'Ações',
  'sinisterStatusOpened': 'Aberto',
  'sinisterStatusClosedWin': 'Fechado',
  'sinisterStatusClosedLost': 'Fechado',
  'sinisterTypeRobbery': 'Roubo',
  'sinisterTypeTheft': 'Furto',
  'sinisterTypeMisappropriation': 'Apropriação Indébita',
  'sinisterTypeAccident': 'Acidente',
  'sinisterTypePositionTracking': 'Rastreamento de Posição',
  'sinisterTypePositionUpdate': 'Atualização de Posição',
  'sinisterTypeOther': 'Outro',
  'sinisterRobbery': 'Roubo',
  'sinisterTheft': 'Furto',
  'sinisterMisappropriation': 'Apropriação Indébita',
  'sinisterAccident': 'Acidente',
  'sinisterOther': 'Outro',
  'sinisterPositionFieldsUnlocked': 'Campos Latitude e Longitude liberados para edição',
  'sinisterPositionFieldsLocked': 'Campos Latitude e Longitude bloqueados para edição',
  'sharedKeyword': 'Palavra-chave',
  'sharedNotifications': 'Notificações',
  'sharedNotification': 'Notificação',
  'sharedAttributes': 'Atributos',
  'sharedAttribute': 'Atributo',
  'sharedDrivers': 'Motoristas',
  'sharedDriver': 'Motorista',
  'sharedArea': 'Área',
  'sharedSound': 'Som de notificação',
  'sharedType': 'Tipo',
  'sharedDistance': 'Distância',
  'sharedHourAbbreviation': 'h',
  'sharedMinuteAbbreviation': 'm',
  'sharedSecondAbbreviation': 's',
  'sharedVoltAbbreviation': 'V',
  'sharedLiterAbbreviation': 'L',
  'sharedGallonAbbreviation': 'Galão',
  'sharedLiter': 'Litro',
  'sharedImpGallon': 'Imp. Galão',
  'sharedUsGallon': 'U.S. Galão',
  'sharedLiterPerHourAbbreviation': 'L/h',
  'sharedLabel': 'Etiqueta',
  'sharedGetMapState': 'Obter estado do mapa',
  'sharedComputedAttribute': 'Atributo Calculado',
  'sharedComputedAttributes': 'Atributos Calculados',
  'sharedCheckComputedAttribute': 'Verificar Atributo Calculado',
  'sharedExpression': 'Expressão',
  'sharedDevice': 'Dispositivo',
  'sharedTestNotification': 'Enviar notificação de teste',
  'sharedCalendar': 'Calendário',
  'sharedCalendars': 'Calendários',
  'sharedFile': 'Arquivo',
  'sharedSelectFile': 'Selecionar Arquivo',
  'sharedPhone': 'Telefone',
  'sharedRequired': 'Necessário',
  'sharedPreferences': 'Preferências',
  'sharedPermissions': 'Permissões',
  'sharedExtra': 'Adicional',
  'sharedTypeString': 'Texto',
  'sharedTypeNumber': 'Número',
  'sharedTypeBoolean': 'Lógico',
  'sharedTimezone': 'Fuso horário',
  'sharedInfoTitle': 'Informação',
  'sharedSavedCommand': 'Comando Salvo',
  'sharedSavedCommands': 'Comandos Salvos',
  'sharedNew': 'Novo...',
  'sharedShowAddress': 'Mostrar Endereço',
  'sharedDisabled': 'Desativado',
  'sharedRealize': 'Realizar',
  'sharedMaintenance': 'Manutenção',
  'sharedMaintenances': 'Manutenções',
  'maintenanceCreatedSuccess': 'Manutenção Cadastrada com Sucesso!',
  'maintenanceEditedSuccess': 'Manutenção Editada com Sucesso!',
  'maintenanceRemovedSuccess': 'Manutenção Removida com Sucesso!',
  'maintenanceRealizedSuccess': 'Manutenção Realizada com Sucesso!',
  'maintenanceFinishedSuccess': 'Manutenção Finalizada com Sucesso!',
  'maintenanceRemoveTitle': 'Remover Manutenção',
  'maintenanceRemoveDescription': 'Tem certeza que deseja remover esta manutenção? Esta ação não pode ser desfeita.',
  'sharedIntegration': 'Integração',
  'sharedIntegrations': 'Integrações',
  'sharedFinancial': 'Financeiro',
  'sharedValue': 'Valor',
  'sharedClear': 'Limpar',
  'integrationRemoveConfirm': 'Você está removendo a integração <strong><field>title</field></strong>! </br>Realmente deseja fazer isso?',
  'integrationConfigRemoveConfirm': 'Você está removendo a integração <strong><field>description</field></strong>! </br>Realmente deseja fazer isso?',
  'sharedIntegrationConfig': 'Configuração de Integração',
  'sharedIntegrationConfigs': 'Configurações de Integração',
  'billingProvider': 'Provider',
  'billingTargetCustomer': 'Cliente final',
  'billingPaid': 'Pago',
  'billingOverdue': 'Vencido',
  'billingRecurring': 'Recorrente',
  'billingOneOff': 'Avulsa',
  'billingCharges': 'Cobranças',
  'billingSubscriptions': 'Assinaturas',
  'billingBillingType': 'Forma de cobrança',
  'billingDueDate': 'Vencimento',
  'billingPaymentDate': 'Pagamento',
  'billingNextDueDate': 'Próximo vencimento',
  'billingRecurrenceType': 'Recorrência',
  'billingCycle': 'Ciclo',
  'billingActiveSubscriptions': 'Assinaturas ativas',
  'billingNewCharge': 'Nova cobrança',
  'billingNewSubscription': 'Nova assinatura',
  'billingCreateCharge': 'Emitir cobrança',
  'billingCreateSubscription': 'Criar assinatura',
  'billingChargeCreatedSuccess': 'Cobrança emitida com sucesso!',
  'billingSubscriptionCreatedSuccess': 'Assinatura criada com sucesso!',
  'billingSubscriptionCancelledSuccess': 'Assinatura cancelada com sucesso!',
  'billingChargeSyncSuccess': 'Cobrança sincronizada com sucesso!',
  'billingSubscriptionSyncSuccess': 'Assinatura sincronizada com sucesso!',
  'billingExternalReference': 'Referência externa',
  'billingEndDate': 'Data final',
  'billingMaxPayments': 'Máximo de cobranças',
  'billingSyncCharge': 'Atualizar cobrança',
  'billingSyncSubscription': 'Atualizar assinatura',
  'billingReuseCharge': 'Usar como base',
  'billingPaymentDetails': 'Pagamento',
  'billingPaymentDetailsTitle': 'Detalhes do pagamento',
  'billingCopyPaymentLink': 'Copiar link',
  'billingPaymentLinkCopied': 'Link de pagamento copiado.',
  'billingPixCodeCopied': 'Código PIX copiado.',
  'billingOpenBankSlip': 'Abrir boleto',
  'billingPixQrCode': 'QR Code PIX',
  'billingPixCopyPaste': 'PIX copia e cola',
  'billingPaymentLink': 'Link de pagamento',
  'billingExternalChargeId': 'ID externo da cobrança',
  'billingPaymentInstructionsPix': 'Envie o QR Code ou o código PIX copia e cola para o cliente.',
  'billingPaymentInstructionsBoleto': 'Abra o boleto para visualizar, imprimir ou compartilhar com o cliente.',
  'billingPaymentInstructionsDefault': 'Abra a cobrança ou copie o link de pagamento para enviar ao cliente.',
  'billingPaymentDetailsUnavailable': 'Não foi possível carregar os detalhes do pagamento.',
  'billingNoPaymentLink': 'Esta cobrança ainda não possui link de pagamento disponível.',
  'billingNoPixQrCode': 'O provider ainda não retornou o QR Code PIX para esta cobrança.',
  'billingSendByWhatsapp': 'WhatsApp',
  'billingSendByEmail': 'E-mail',
  'billingCustomerPhoneUnavailable': 'O cliente final não possui telefone/celular cadastrado.',
  'billingCustomerEmailUnavailable': 'O cliente final não possui e-mail cadastrado.',
  'billingOpenInvoice': 'Abrir cobrança',
  'billingCancelSubscription': 'Cancelar assinatura',
  'billingSummaryTotalCharges': 'Total de cobranças',
  'billingSummaryPaidCharges': 'Cobranças pagas',
  'billingSummaryUnpaidCharges': 'Em aberto',
  'billingSummaryOverdueCharges': 'Vencidas',
  'billingSummaryRecurringCharges': 'Cobranças recorrentes',
  'billingSummaryActiveSubscriptions': 'Assinaturas ativas',
  'billingSummarySuspendedCustomers': 'Clientes suspensos',
  'billingSummaryChargeCount': '{count, plural, =0 {# cobranças} one {# cobrança} other {# cobranças}}',
  'billingSummarySubscriptionCount': '{count, plural, =0 {# assinaturas} one {# assinatura} other {# assinaturas}}',
  'billingChargeStatusPending': 'Pendente',
  'billingChargeStatusReceived': 'Recebida',
  'billingChargeStatusConfirmed': 'Confirmada',
  'billingChargeStatusReceivedInCash': 'Recebida em dinheiro',
  'billingChargeStatusOverdue': 'Vencida',
  'billingSubscriptionStatusActive': 'Ativa',
  'billingSubscriptionStatusInactive': 'Inativa',
  'billingSubscriptionStatusCancelled': 'Cancelada',
  'billingSubscriptionStatusExpired': 'Expirada',
  'billingSubscriptionStatusDeleted': 'Removida',
  'billingChargeStatusRefunded': 'Estornada',
  'billingChargeStatusDeleted': 'Removida',
  'billingChargeStatusRefundRequested': 'Estorno solicitado',
  'billingChargeStatusRefundInProgress': 'Estorno em processamento',
  'billingChargeStatusChargebackRequested': 'Chargeback recebido',
  'billingChargeStatusChargebackDispute': 'Em disputa de chargeback',
  'billingChargeStatusAwaitingChargebackReversal': 'Aguardando reversão de chargeback',
  'billingChargeStatusDunningRequested': 'Em negativação',
  'billingChargeStatusDunningReceived': 'Recebida (negativação)',
  'billingChargeStatusAwaitingRiskAnalysis': 'Em análise de risco',
  'billingProviderNotConfigured': 'Não há integração Asaas ativa para esta central. Configure a integração para emitir cobranças e assinaturas.',
  'billingProviderMissingToken': 'A integração Asaas desta central está sem a chave de API. Informe a chave na configuração da integração para emitir cobranças e assinaturas.',
  'billingProviderMultipleConfigs': 'Esta central tem mais de uma integração Asaas ativa. Deixe só uma ativa na configuração da integração para emitir cobranças e assinaturas.',
  'billingConfigureIntegration': 'Configurar integração',
  'billingCancelSubscriptionConfirm': 'Cancelar definitivamente',
  'billingCancelSubscriptionConfirmDescription': 'O cancelamento é definitivo no Asaas: a recorrência é encerrada e as cobranças pendentes e vencidas desta assinatura são removidas. Deseja continuar?',
  'billingCycleWeekly': 'Semanal',
  'billingCycleBiweekly': 'Quinzenal',
  'billingCycleMonthly': 'Mensal',
  'billingCycleBimonthly': 'Bimestral',
  'billingCycleQuarterly': 'Trimestral',
  'billingCycleSemiannually': 'Semestral',
  'billingCycleYearly': 'Anual',
  'sharedDeviceAccumulators': 'Bateria',
  'sharedAlarms': 'Alarmes',
  'mapStreets': 'Ruas',
  'sharedClose': 'Fechar',
  'sharedColor': 'Cor',
  'sharedSavedSuccess': 'Seus dados foram salvos',
  'sharedRemovedSuccess': 'Seus dados foram removidos',
  'sharedUpdatedSuccess': 'Seus dados foram atualizados',
  'permissionsUpdatedSuccess': 'Permissões atualizadas com sucesso!',
  'sharedUrlInvalid': 'Digite uma URL válida',
  'sharedError': 'Ops! Erro interno',
  'sharedBadRequest': 'Operação não autorizada',
  'sharedForbidden': 'Não possui direitos de acesso',
  'sharedUnauthorized': 'Usuário não autenticado',
  'sharedNotFound': 'Não encontrado',
  'sharedActivated': 'Ativado',
  'sharedNotActivated': 'Desativado',
  'sharedDate': 'Data',
  'sharedUserPaymentDetail': 'Dados para Pagamento',
  'sharedUser': 'Usuário',
  'sharedCustomers': 'Clientes',
  'sharedCustomer': 'Cliente',
  'deviceOwnerCustomer': 'Central',
  'sharedAddress': 'Endereço',
  'sharedNoResultsFound': 'Nenhum resultado encontrado!',
  'sharedChooseADevice': 'Escolha um dispositivo',
  'attributeSpeedLimit': 'Limite de Velocidade',
  'attributePolylineDistance': 'Distância da Polilinha',
  'attributeReportIgnoreOdometer': 'Ignorar odômetro do dispositivo',
  'attributeWebReportColor': 'Web: Cor do Relatório',
  'attributeDevicePassword': 'Senha do Dispositivo',
  'attributeProcessingCopyAttributes': 'Processamento: Copiar Atributos',
  'attributeColor': 'Cor',
  'attributeWebLiveRouteLength': 'Web: Comprimento da Rota ao Vivo',
  'attributeWebSelectZoom': 'Web: Zoom Selecionado',
  'attributeWebMaxZoom': 'Web: Zoom Máximo',
  'attributeMailSmtpHost': 'Email: Host SMTP',
  'attributeMailSmtpPort': 'Email: Porta SMTP',
  'attributeMailSmtpStarttlsEnable': 'Email: Ativar STARTTLS (SMTP)',
  'attributeMailSmtpStarttlsRequired': 'Email: SMTP START TLS Obrigatório',
  'attributeMailSmtpSslEnable': 'Email: Ativar SSL (SMTP)',
  'attributeMailSmtpSslTrust': 'Email: Certificado SSL (SMTP)',
  'attributeMailSmtpSslProtocols': 'Email: Protocolo SSL (SMTP)',
  'attributeMailSmtpFrom': 'Email: Remetente',
  'attributeMailSmtpAuth': 'Email: Ativar Autenticação (SMTP)',
  'attributeMailSmtpUsername': 'Email: Nome de Usuário (SMTP)',
  'attributeMailSmtpPassword': 'Email: Senha (SMTP)',
  'attributeUiDisableReport': 'UI: Disabilita Relatório',
  'attributeUiDisableEvents': 'UI: Eventos Desativados',
  'attributeUiDisableVehicleFetures': 'UI: Desativar Características do Veículo',
  'attributeUiDisableDrivers': 'UI: Desativar Motoristas',
  'attributeUiDisableComputedAttributes': 'UI: Desativar Atributos Calculados',
  'attributeUiDisableCalendars': 'UI: Desativar Calendários',
  'attributeUiDisableMaintenances': 'Desativar Manutenções',
  'attributeUiHidePositionAttributes': 'UI: Ocultar os atributos de posição',
  'errorAuthorization': 'Autorização de credencial inválida, verifique e-mail e senha.',
  'errorTitle': 'Erro',
  'errorGeneral': 'Parâmetros inválidos ou violação de restrições',
  'errorConnection': 'Erro de conexão',
  'errorSocket': 'Erro na conexão com Web Socket',
  'errorZero': 'Não pode ser zero',
  'userEmail': 'Email',
  'userPassword': 'Senha',
  'userAdmin': 'Admin',
  'userRemember': 'Lembrar',
  'userExpirationTime': 'Expiração',
  'userDeviceLimit': 'Limite de dispositivos',
  'userUserLimit': 'Limite de Usuários',
  'userDeviceReadonly': 'Padrão',
  'userLimitCommands': 'Não envia comandos',
  'userToken': 'Token',
  'userKeyword': 'Palavra-chave',
  'loginTitle': 'Acessar',
  'loginLanguage': 'Idioma',
  'loginRegister': 'Registrar',
  'loginLogin': 'Entrar',
  'loginFailed': 'Email ou senha incorretos',
  'loginCreated': 'Novo usuário registrado',
  'loginLogout': 'Sair',
  'loginLogo': 'Logotipo',
  'devicePositionUpdateSuccess': 'Posição do dispositivo atualizada com sucesso!',
  'devicesAndState': 'Dispositivo e Estado',
  'deviceTitle': 'Dispositivos',
  'deviceIdentifier': 'Identificador',
  'deviceImei': 'IMEI',
  'deviceModel': 'Modelo',
  'deviceContact': 'Contato',
  'deviceCategory': 'Categoria',
  'deviceLastUpdate': 'Última Atualização',
  'deviceActionsTitle': 'Ações para o Dispositivo',
  'deviceInfoTitle': 'Informações do Dispositivo',
  'deviceNotIdentified': 'Não identificado',
  'deviceModalTitle': 'Título',
  'mapShareLinkCopied': 'Link de compartilhamento copiado para a área de transferência.',
  'hashNotValidTitle': 'Link inválido ou expirado!',
  'hashRedirectMessage': 'Você será redirecionado para a página de login em alguns instantes.',
  'hashBackToLogin': 'Voltar à página de login.',
  'hashValidatingTitle': 'Carregando...',
  'mapSatellite': 'Satélite',
  'deviceDeviceTime': 'Dispositivo',
  'deviceServerTime': 'Servidor',
  'deviceStoppedFor': 'Parado há',
  'deviceLimit': 'Limite de Dispositivos',
  'deviceCommand': 'Comando',
  'deviceFollow': 'Seguir',
  'deviceRoute': 'Rota',
  'deviceBlock': 'Bloquear',
  'deviceRelease': 'Liberar',
  'deviceFence': 'Cerca',
  'deviceShare': 'Compartilhar',
  'deviceTotalDistance': 'Distância total',
  'deviceOdometerHourmeter': 'Odômetro/Horímetro',
  'accumulatorUnitKm': 'km',
  'accumulatorUnitMi': 'mi',
  'accumulatorUnitNmi': 'mn',
  'accumulatorCurrentOdometer': 'Odômetro atual ({unit})',
  'accumulatorCurrentHourmeter': 'Horímetro atual (horas)',
  'accumulatorStoppedNotice': 'Só é possível editar com o veículo parado. Em deslocamento, tente novamente após a parada.',
  'accumulatorEditHint': 'Clique para editar odômetro e horímetro',
  'accumulatorPlatformOdometerEnabled': 'O odômetro da plataforma foi ligado para este veículo: os relatórios passam a usá-lo no lugar do odômetro do dispositivo.',
  'accumulatorPlatformOdometerNotice': 'Ao salvar, os relatórios deste veículo passam a usar o odômetro da plataforma, e não o do dispositivo.',
  'accumulatorRangeError': 'Informe um valor entre 0 e {max}.',
  'accumulatorDecimalError': 'Use no máximo uma casa decimal.',
  'accumulatorRolledOver': 'O contador atingiu o máximo e reiniciou em 0. Ele não pode mais ser editado.',
  'accumulatorNoPosition': 'Este dispositivo ainda não reportou posição. O odômetro e o horímetro só podem ser editados depois da primeira posição.',
  'accumulatorNothingChanged': 'Nenhum valor foi alterado.',
  'accumulatorNeverEdited': 'Nunca editado',
  'accumulatorFieldOdometer': 'Odômetro',
  'accumulatorFieldHourmeter': 'Horímetro',
  'accumulatorLowerBlocked': 'Este campo já foi editado: só é possível informar {min} ou mais.',
  'accumulatorColRegistered': 'Data de cadastro',
  'accumulatorColField': 'Campo',
  'accumulatorColPrevious': 'Último valor registrado',
  'accumulatorColEditedAt': 'Data de edição',
  'accumulatorColNew': 'Valor editado',
  'accumulatorColUser': 'Usuário que editou',
  'accumulatorColEmail': 'E-mail do usuário',
  'accumulatorHistoryError': 'Não foi possível carregar as edições do odômetro e do horímetro.',
  'deviceTrail': 'Rastro',
  'deviceStatus': 'Estado',
  'deviceStatusOnline': 'Conectado',
  'deviceStatusOffline': 'Desconectado',
  'deviceStatusUnknown': 'Desconhecido',

  'deviceM2mProvider': 'Operadora do Chip',
  'deviceIccid': 'ICCID',
  'devicePlate': 'Placa',
  'deviceYear': 'Ano',
  'deviceVehicleModel': 'Modelo do Veículo',
  'deviceFipeSearchPlaceholder': 'Digite marca ou modelo…',
  'deviceFipeSearchEmpty': 'Nenhum veículo encontrado',
  'deviceFipeSearchError': 'Falha ao buscar na FIPE',
  'deviceFipeResolveError': 'Falha ao carregar dados do veículo',
  'deviceFuelType': 'Combustível',
  'deviceFuelConsumption': 'Consumo',
  'deviceManufacturer': 'Marca',
  'deviceColor': 'Cor',
  'deviceRenavam': 'Renavam',
  'deviceChassi': 'Chassi',
  'deviceInstallationLocation': 'Local de instalação',
  'deviceTechnician': 'Instalador',
  'devicePassword': 'Senha',
  'deviceSpeedLimit': 'Limite de Velocidade',
  'deviceIgnoreOdometerOff': 'Odômetro do dispositivo (GPS padrão)',
  'deviceIgnoreOdometerOn': 'Odômetro da plataforma',
  'deviceIsShareable': 'Espelhamento com PRF',
  'deviceIsMirrorable': 'Espelhamento com Herrlog',
  'deviceSelectedNeverPositioned': 'O dispositivo selecionado nunca posicionou.',

  'deviceImage': 'Imagem',
  'deviceImagesDndTitle': 'Arraste e solte as imagens aqui',
  'deviceImagesDndSupportedExtensions': 'JPEG e PNG, até 1 MB.',
  'deviceImagesSelectFile': 'Selecionar Arquivo',
  'deviceImagesSelectFileHelper': '*Máximo de 4 uploads',
  'deviceImagePinAction': 'Destacar Imagem',
  'deviceImageRemoveAction': 'Excluir',
  'deviceImagesUnlockEdition': 'Desbloquear edição',
  'deviceImagesUnlockDialogTitle': 'Atenção',
  'deviceImagesUnlockDialogContent': 'Caso você opte por desbloquear a edição, então você perderá as imagens que já possui.',
  'deviceImagesUnlockDialogConfirm': 'Desbloquear',
  'deviceImagesUnlockDialogCancel': 'Cancelar',
  'deviceVehicleImage': 'Imagem Veículo',
  'deviceVehicleImageEmpty': 'Não há imagens.',
  'deviceMoreInfo': 'Mais Informações',
  'deviceNoMoreInfo': 'Sem mais informações.',
  'geofenceCreateSuccess': 'Cerca criada com sucesso',
  'geofenceCreateFail': 'Não foi possível realizar sua solicitação!',
  'geofenceCreateFailed': 'Não foi possível realizar sua solicitação!',

  'groupDialog': 'Grupo',
  'groupParent': 'Grupo',
  'groupNoGroup': 'Sem Grupo',
  'settingsTitle': 'Configurações',
  'settingsUser': 'Conta',
  'settingsGroups': 'Grupos',
  'settingsServer': 'Servidor',
  'settingsUsers': 'Usuários',
  'settingsDistanceUnit': 'Unidade de Distância',
  'settingsSpeedUnit': 'Unidade de Velocidade',
  'settingsVolumeUnit': 'Unidade de Volume',
  'settingsTwelveHourFormat': 'Formato 12 horas AM/PM',
  'settingsCoordinateFormat': 'Formato de coordenadas',
  'reportTitle': 'Relatórios',
  'reportDevice': 'Dispositivo',
  'reportGroup': 'Grupo',
  'reportFrom': 'De',
  'reportTo': 'Para',
  'reportShow': 'Mostrar',
  'reportClear': 'Limpar',
  'reportDaily': 'Diário',
  'positionFixTime': 'Tempo',
  'positionValid': 'Válido',
  'positionAccuracy': 'Precisão',
  'positionLatitude': 'Latitude',
  'positionLongitude': 'Longitude',
  'positionAltitude': 'Altitude',
  'positionSpeed': 'Velocidade',
  'positionCourse': 'Direção',
  'positionAddress': 'Endereço',
  'positionProtocol': 'Protocolo',
  'positionDistance': 'Distância',
  'positionRpm': 'RPM',
  'positionFuel': 'Combustível',
  'positionPower': 'Tensão',
  'positionBattery': 'Bateria',
  'positionBatteryVoltage': 'Tensão Bat.',
  'positionRaw': 'Bruto',
  'positionIndex': 'Índice',
  'positionHdop': 'HDOP',
  'positionVdop': 'VDOP',
  'positionPdop': 'PDOP',
  'positionSat': 'Sátelites',
  'positionSatVisible': 'Satélites Visíveis',
  'positionRssi': 'RSSI',
  'positionGps': 'GPS',
  'positionRoaming': 'Roaming',
  'positionEvent': 'Evento',
  'positionAlarm': 'Alarme',
  'positionStatus': 'Estado',
  'positionOdometer': 'Odômetro',
  'positionServiceOdometer': 'Odômetro de Serviço',
  'positionTripOdometer': 'Odômetro de Viagem',
  'positionHours': 'Horímetro',
  'positionSteps': 'Passos',
  'positionInput': 'Entrada',
  'positionOutput': 'Saída',
  'positionBatteryLevel': 'Nível de Bateria',
  'positionFuelConsumption': 'Consumo de Combustível',
  'positionRfid': 'RFID',
  'positionVersionFw': 'Versão de Firmware',
  'positionVersionHw': 'Versão de Hardware',
  'positionIgnition': 'Ignição',
  'positionFlags': 'Sinais',
  'positionCharge': 'Carga',
  'positionIp': 'IP',
  'positionArchive': 'Arquivar',
  'positionVin': 'VIN',
  'positionApproximate': 'Estimado',
  'positionThrottle': 'Acelerador',
  'positionMotion': 'Movimento',
  'positionArmed': 'Alarme Ativado',
  'positionAcceleration': 'Aceleração',
  'positionDeviceTemp': 'Temperatura do Dispositivo',
  'positionOperator': 'Operadora',
  'positionCommand': 'Comando',
  'positionBlocked': 'Bloqueado',
  'positionDtcs': 'DTCs',
  'positionObdSpeed': 'Velocidade OBD',
  'positionObdOdometer': 'Odômetro OBD',
  'positionDriverUniqueId': 'Identificador Único Motorista',
  'positionStoppedTime': 'Tempo Parado',
  'positionImage': 'Imagem',
  'positionAudio': 'Áudio',
  'positionTotalDistance': 'Distância Total',
  'positionType': 'Tipo',
  'positionIn': 'Entrada',
  'positionOut': 'Saída',
  'serverTitle': 'Configurações do Servidor',
  'serverZoom': 'Zoom',
  'serverRegistration': 'Registro',
  'serverReadonly': 'Apenas Visualizar',
  'serverForceSettings': 'Forçar configurações',
  'mapTitle': 'Mapa',
  'mapLayer': 'Camada de Mapa',
  'mapCustom': 'Mapa Personalizado',
  'mapCarto': 'Carto Basemaps',
  'mapOsm': 'Open Street Map',
  'mapBingKey': 'Bing Mapas API Key',
  'mapBingRoad': 'Bing Mapas Estradas',
  'mapBingAerial': 'Bing Mapas Aéreo',
  'mapBingHybrid': 'Bing Mapas Híbrido',
  'mapBaidu': 'Baidu',
  'mapYandexMap': 'Mapa Yandex',
  'mapYandexSat': 'Satélite Yandex',
  'mapWikimedia': 'Wikimedia',
  'mapShapePolygon': 'Polígono',
  'mapShapeCircle': 'Círculo',
  'mapShapePolyline': 'Polilinha',
  'mapLiveRoutes': 'Rotas ao Vivo',
  'mapPoiLayer': 'Camada POI',
  'mapKindStreet': 'Rua',
  'mapKindSatellite': 'Satélite',
  'mapKindNotAvailable': 'Mapa indisponível!',
  'stateTitle': 'Estado',
  'stateName': 'Atributo',
  'stateValue': 'Valor',
  'commandTitle': 'Comando',
  'commandSend': 'Enviar',
  'commandBlockConfirm': 'Tem certeza que deseja bloquear o veículo {name}?',
  'commandUnblockConfirm': 'Tem certeza que deseja desbloquear o veículo {name}?',
  'commandSent': 'Comando enviado',
  'deviceNoLongerAccessible': 'Este dispositivo não pertence mais à sua conta. Atualizando a página...',
  'deviceNoLongerAccessibleShared': 'Este dispositivo não está mais disponível neste link. Atualizando a página...',
  'commandQueued': 'Comando na fila',
  'commandUnit': 'Unidade',
  'commandMotionInterval': 'Intervalo de movimento',
  'commandStopInterval': 'Intervalo parado',
  'commandResetOdometer': 'Zerar Odômetro',
  'commandAlarmIdle': 'Alarme de Ociosidade',
  'commandAlarmRemove': 'Remover Alarme',
  'commandCustom': 'Comando personalizado',
  'commandDeviceIdentification': 'Identificação do dispositivo',
  'commandPositionSingle': 'Relatório avulso',
  'commandPositionPeriodic': 'Atualização Periódica',
  'commandPositionStop': 'Parar Atualização',
  'commandEngineStop': 'Desligar Motor',
  'commandEngineResume': 'Religar Motor',
  'commandAlarmArm': 'Ativar Alarme',
  'commandAlarmDisarm': 'Desativar Alarme',
  'commandSetTimezone': 'Definir fuso horário',
  'commandRequestPhoto': 'Pegar foto',
  'commandRebootDevice': 'Reiniciar dispositivo',
  'commandSendSms': 'Enviar SMS',
  'commandSendUssd': 'Enviar USSD',
  'commandSosNumber': 'Definir numero SOS',
  'commandSilenceTime': 'Definir Tempo no Silencioso',
  'commandSetPhonebook': 'Definir lista telefônica',
  'commandVoiceMessage': 'Mensagem de voz',
  'commandOutputControl': 'Controle de saída',
  'commandVoiceMonitoring': 'Monitoramento de Voz',
  'commandSetAgps': 'Definir AGPS',
  'commandSetIndicator': 'Definir Indicador',
  'commandConfiguration': 'Configuração',
  'commandGetVersion': 'Obter Versão',
  'commandFirmwareUpdate': 'Atualizar Firmware',
  'commandSetConnection': 'Definir Conexão',
  'commandSetOdometer': 'Definir Odômetro',
  'commandGetModemStatus': 'Obter Status do Modem',
  'commandGetDeviceStatus': 'Obter status do dispositivo',
  'commandModePowerSaving': 'Modificar a Economia de Energia',
  'commandModeDeepSleep': 'Modifique o Sono Profundo',
  'commandMovementAlarm': 'Alarme de Movimento',
  'commandFrequency': 'Frequência',
  'commandTimezone': 'Ajuste de Fuso horário',
  'commandMessage': 'Mensagem',
  'commandRadius': 'Raio',
  'commandEnable': 'Habilitar',
  'commandData': 'Valor',
  'commandIndex': 'Índice',
  'commandPhone': 'Número de Telefone',
  'commandServer': 'Servidor',
  'commandPort': 'Porta',
  'eventAll': 'Todos Eventos',
  'eventDeviceOnline': 'Status online',
  'eventDeviceUnknown': 'Status desconhecido',
  'eventDeviceOffline': 'Status offline',
  'eventDeviceMoving': 'Dispositivo movendo',
  'eventDeviceStopped': 'Dispositivo parado',
  'eventDeviceInactive': 'Dispositivo Inativo',
  'eventDeviceOverspeed': 'Excedido o limite de velocidade',
  'eventDeviceFuelDrop': 'Queda de combustível',
  'eventCommandResult': 'Resultado do comando',
  'eventCommandSent': 'Comando enviado',
  'eventGeofenceEnter': 'Entrada na cerca virtual',
  'eventGeofenceExit': 'Saída da cerca virtual',
  'eventAlarm': 'Alarme',
  'eventIgnitionOn': 'Ignição ligada',
  'eventIgnitionOff': 'Ignição desligada',
  'eventMaintenance': 'Manutenção necessária',
  'eventTextMessage': 'Mensagem de texto recebida',
  'eventDriverChanged': 'Condutor alterado',
  'eventQueuedCommandSent': 'Comando na fila enviado',
  'eventDeviceFuelIncrease': 'Aumento de combustível',
  'eventMedia': 'Mídia',
  'eventReportReady': 'Relatório pronto',
  'eventsScrollToLast': 'Rolar para o último',
  'alarmGeneral': 'Genérico',
  'alarmSos': 'SOS',
  'alarmVibration': 'Vibrando',
  'alarmMovement': 'Movendo',
  'alarmLowspeed': 'Baixa velocidade',
  'alarmOverspeed': 'Excesso de velocidade',
  'alarmFallDown': 'Queda',
  'alarmLowPower': 'Baixa potência',
  'alarmLowBattery': 'Bateria Fraca',
  'alarmFault': 'Falha',
  'alarmPowerOff': 'Alimentação desligada',
  'alarmPowerOn': 'Alimentação ligada',
  'alarmDoor': 'Porta',
  'alarmLock': 'Bloqueio',
  'alarmUnlock': 'Desbloqueio',
  'alarmGeofence': 'Cerca virtual',
  'alarmGeofenceEnter': 'Entrando na cerca virtual',
  'alarmGeofenceExit': 'Saiu da Cerca virtual',
  'alarmGpsAntennaCut': 'Antena de GPS cortada',
  'alarmAccident': 'Acidente',
  'alarmTow': 'Rebocar',
  'alarmIdle': 'Ocioso',
  'alarmHighRpm': 'Alto RPM',
  'alarmHardAcceleration': 'Aceleração difícil',
  'alarmHardBraking': 'Frenagem brusca',
  'alarmHardCornering': 'Curva perigosa',
  'alarmLaneChange': 'Mudança de faixa',
  'alarmFatigueDriving': 'Condutor Cansado',
  'alarmPowerCut': 'Alimentação cortada',
  'alarmPowerRestored': 'Alimentação restaurada',
  'alarmJamming': 'Interferência',
  'alarmTemperature': 'Temperatura',
  'alarmParking': 'Estacionamento',
  'alarmShock': 'Choque',
  'alarmBonnet': 'Capô',
  'alarmFootBrake': 'Freio de mão',
  'alarmFuelLeak': 'Vazamento de combustível',
  'alarmTampering': 'Manipulando',
  'alarmRemoving': 'Removendo',
  'notificationType': 'Tipo de Notificação',
  'notificationAlways': 'Todos os Dispositivos',
  'notificationReportReadyRequiresAlways': 'Notificação de relatório pronto só pode ser criada com "Todos os Dispositivos" marcado.',
  'notificationNotificators': 'Canais',
  'notificatorWeb': 'Web',
  'notificatorMail': 'E-Mail',
  'notificatorSms': 'SMS',
  'notificatorFirebase': 'Móvel',
  'reportNew': 'Novo Relatório',
  'commandNew': 'Novo Comando',
  'sinisterNew': 'Novo Sinistro',
  'sinisterOccurrenceAddedSuccess': 'Ocorrência Adicionada com Sucesso',
  'sinisterOccurrenceCreateError': 'Erro ao tentar criar Ocorrência',
  'sinisterClosedSuccess': 'Sinistro Fechado com Sucesso',
  'sinisterAddImage': 'Adicionar Imagem',
  'sinisterTimeField': 'Horário*',
  'sinisterEssentialInfo': 'Informações Essências',
  'sinisterAddOccurrence': '+ Adicionar Ocorrência',
  'sinisterHistory': 'Histórico',
  'sinisterFillEssentialInfo': 'Preencha as informações essências para cadastrar o novo sinistro!',
  'sinisterOccurrenceLabel': 'Ocorrência',
  'sinisterTimeLabel': 'Horário:',
  'sinisterOccurrenceText': 'Ocorrência:',
  'sinisterEssentialInfoTitle': 'Informações Essenciais',
  'sinisterDownloadReport': 'Baixar Relatório',
  'sinisterReportedBy': 'Relatado Por',
  'sinisterDescription': 'Faça uma descrição do evento ocorrido',
  'sinisterInfoLabel': 'Informações:',
  'sinisterPdfFileName': 'relatório.pdf',
  'sinisterOccurrenceTitle': 'Ocorrência - {type}',
  'reportMarkersSampled': 'Relatório com {count} posições: mostrando um marcador a cada {step}. O traço da rota está completo.',
  'reportRoute': 'Rota',
  'reportEvents': 'Eventos',
  'reportTrips': 'Viagens',
  'reportStops': 'Paradas',
  'reportSummary': 'Resumo',
  'reportChart': 'Gráfico',
  'reportConfigure': 'Configurar',
  'reportEventTypes': 'Tipos de Eventos',
  'reportChartType': 'Tipo do Gráfico',
  'reportShowMarkers': 'Mostrar Marcadores',
  'reportExport': 'Solicitar Planilha',
  'reportExportPdf': 'Solicitar PDF',
  'reportEmail': 'Relatório de E-mail',
  'reportPeriod': 'Período',
  'reportCustom': 'Personalizadas',
  'reportToday': 'Hoje',
  'reportYesterday': 'Ontem',
  'reportThisWeek': 'Esta Semana',
  'reportPreviousWeek': 'Semana Anterior',
  'reportThisMonth': 'Este Mês',
  'reportPreviousMonth': 'Mês Anterior',
  'reportCurrentMonth': 'Este mês',
  'reportCustomPeriod': 'Personalizado',
  'reportChoosePeriod': 'Escolha o período',
  'reportChooseDevices': 'Escolha dispositivo(s)',
  'reportChooseGroups': 'Escolha o grupo',
  'reportChooseEvents': 'Escolha evento(s)',
  'reportSendByEmail': 'Solicitar envio de e-mail',
  'reportGoTo': 'Relatório no Mapa',
  'reportFileNamePattern': 'Relatório de {report}',
  'reportFileNameManyDevices': 'vários dispositivos',
  'reportFileNameOneDevice': '1 dispositivo',
  'reportFileNameDeviceCount': '{count} dispositivos',
  'reportFileNameDays': '{count} dias',
  'reportPeriodLimit': 'O relatório comporta no máximo {days} dias. Para um período maior, gere um relatório a cada {days} dias.',
  'reportEmailNotConfigured': 'O envio de e-mails não está configurado. Fale com a sua Central.',
  'reportValid': 'Válido',
  'reportSpeed': 'Velocidade',
  'reportDateAndTime': 'Data e Hora',
  'reportObservation': 'Observação',
  'reportMaintenanceEntry': 'Manutenção: {name}',
  'reportAlarmType': 'Tipo do alarme: {name}',
  'reportGeofenceEntry': 'Cerca: {name}',
  'reportCommandSentBy': 'Comando {command} enviado por usuário: {name} - e-mail: {email}',
  'reportCommandSentNoUser': 'Comando {command} enviado',
  'reportRouteResult': 'Resultado: {result}',
  'reportEmailSuccess': 'Você receberá seu relatório no e-mail',
  'reportEmailError': 'Não foi possível realizar sua solicitação!',
  'reportJobQueued': 'Gerando o relatório. Você pode fechar esta tela — avisaremos quando estiver pronto.',
  'reportJobQueuedEstimate': 'Gerando o relatório, pronto em até {estimate}. Você pode fechar esta tela — avisaremos quando estiver pronto.',
  'reportJobAlreadyReady': 'Relatório gerado. Verifique se já baixou.',
  'sharedReportJobs': 'Relatórios Solicitados',
  'reportJobsEmpty': 'Nenhum relatório foi solicitado.',
  'reportJobLinkNotFound': 'Relatório não encontrado. O link pode ser de outra conta ou o relatório já expirou.',
  'reportJobStatusPending': 'Na fila',
  'reportJobStatusRunning': 'Gerando',
  'reportJobStatusDone': 'Pronto',
  'reportJobStatusFailed': 'Falhou',
  'reportJobStatusCancelled': 'Cancelado',
  'reportJobStatusExpired': 'Expirado',
  'reportJobDownload': 'Baixar',
  'reportJobCancel': 'Cancelar',
  'reportJobCancelConfirm': 'Cancelar este relatório? Se ainda não tiver sido gerado, a geração é interrompida antes de concluir.',
  'reportJobColumnReport': 'Relatório',
  'reportJobColumnRequested': 'Solicitado em',
  'reportJobColumnRequester': 'Solicitado por',
  'reportJobColumnStatus': 'Status',
  'reportJobColumnEstimate': 'Estimativa',
  'reportJobEstimateFinishing': 'finalizando…',
  'reportJobEstimateCalculating': 'calculando…',
  'reportJobDurationSeconds': '{count} s',
  'reportJobDurationMinutes': '{count} min',
  'reportJobDurationHours': '{count} h',
  'reportJobDurationDays': '{count, plural, one {# dia} other {# dias}}',
  'reportJobDurationMonths': '{count, plural, one {# mês} other {# meses}}',
  'reportJobColumnGenerated': 'Gerado em',
  'reportJobDevicesButton': 'Dispositivos',
  'reportJobDevicesModalTitle': 'Dispositivos do relatório',
  'reportJobDevicesEmpty': 'Nenhum dispositivo encontrado para este relatório.',
  'reportJobDevicesImei': 'IMEI',
  'reportJobDevicesTotalDistance': 'Distância Total Percorrida',
  'reportLoadError': 'Não foi possível carregar o relatório.',
  'reportJobErrorNotReady': 'O relatório ainda não está pronto.',
  'reportJobErrorAlreadyFinished': 'Este relatório já terminou e não pode ser cancelado.',
  'reportJobErrorUnsupportedType': 'Este tipo de relatório não está disponível na fila.',
  'reportJobErrorUnsupportedFormat': 'Este formato de relatório não está disponível.',
  'reportJobErrorInvalidPeriod': 'Informe um período válido: a data inicial deve ser anterior à final.',
  'reportJobErrorNoDevices': 'Nenhum dispositivo disponível para este relatório.',
  'reportJobErrorStorageNotConfigured': 'A geração de relatórios não está configurada. Fale com a sua Central.',
  'reportJobMailTooLarge': 'O relatório está pronto, mas é grande demais para ser enviado por e-mail. Baixe o arquivo em Relatórios Solicitados.',
  'reportJobDevicesError': 'Não foi possível carregar os dispositivos deste relatório.',
  'reportJobFailureWorkerDied': 'A geração foi interrompida antes de terminar. Solicite o relatório novamente.',
  'reportJobFailureGenerationFailed': 'Não foi possível gerar o relatório. Solicite novamente.',
  'reportJobFailureUnknown': 'A geração do relatório falhou.',
  'reportChooseReport': 'Escolha um relatório',
  'reportJourney': 'Percurso',
  'reportCertadocFines': 'Multas (Certadoc)',
  'certadocCheckFines': 'Consultar Multa',
  'certadocFines': 'Multas',
  'certadocNoFines': 'Nenhuma multa retornada para esta placa. Confirme se o veículo está cadastrado na Certadoc.',
  'certadocNoPlate': 'Dispositivo sem placa cadastrada. Solicite o cadastro da placa para a sua Central.',
  'certadocRequestError': 'Não foi possível consultar as multas na Certadoc.',
  'certadocColCategory': 'Categoria',
  'certadocColAit': 'AIT',
  'certadocColDate': 'Data',
  'certadocColTime': 'Hora',
  'certadocColDescription': 'Infração',
  'certadocColValue': 'Valor (R$)',
  'certadocColSituation': 'Situação',
  'certadocColStatus': 'Status',
  'certadocColAgency': 'Órgão',
  'certadocColCode': 'Cód. infração',
  'certadocColDueDate': 'Vencimento',
  'certadocColAddress': 'Endereço',
  'certadocColCity': 'Município',
  'certadocColState': 'UF',
  'certadocColDocuments': 'Documentos',
  'certadocDocumentTicket': 'Boleto',
  'certadocDocumentSupport': 'Respaldo',
  'certadocCategoryPagas': 'Pagas',
  'certadocCategoryAPagar': 'A pagar',
  'certadocCategoryNotificacoes': 'Notificações',
  'certadocCategoryMultasNic': 'Multas NIC',
  'certadocCategoryOutros': 'Outros',
  'reportDeviceName': 'Nome do Dispositivo',
  'reportAverageSpeed': 'Velocidade Média',
  'reportMaximumSpeed': 'Velocidade Máxima',
  'reportEngineHours': 'Horas ligado',
  'reportStationaryHours': 'Horas Parado',
  'reportIdleHours': 'Horas Ocioso',
  'reportDuration': 'Duração',
  'reportStartTime': 'Hora inicial',
  'reportStartAddress': 'Endereço inicial',
  'reportEndTime': 'Hora final',
  'reportEndAddress': 'Endereço final',
  'reportSpentFuel': 'Gasto de Combustível',
  'reportStartOdometer': 'Início do odômetro',
  'reportEndOdometer': 'Fim do odômetro',
  'statisticsTitle': 'Estatísticas',
  'statisticsCaptureTime': 'Tempo de Captura',
  'statisticsActiveUsers': 'Usuários ativos',
  'statisticsActiveDevices': 'Dispositivos ativos',
  'statisticsRequests': 'Pedidos',
  'statisticsMessagesReceived': 'Mensagens Recebidas',
  'statisticsMessagesStored': 'Mensagens armazenadas',
  'statisticsGeocoder': 'Solicitações de Geocódigo',
  'statisticsGeolocation': 'Solicitações de Geolocalização',

  'maintenanceStart': 'Começar',
  'maintenancePeriod': 'Período',

  'customerCpfCnpj': 'CPF/CNPJ',
  'customerType': 'Tipo',
  'customerName': 'Nome',
  'customerStreet': 'Rua',
  'customerNumber': 'Número',
  'customerComplement': 'Complemento',
  'customerNeighborhood': 'Bairro',
  'customerCity': 'Cidade',
  'customerState': 'Estado',
  'customerPostalCode': 'CEP',
  'customerPhone': 'Telefone',
  'customerCellphone': 'Celular',
  'customerNotificationEmail': 'E-mail principal',
  'customerSecondaryEmail': 'E-mail secundário',
  'customerCategory': 'Categoria',
  'customerCategoryClient': 'Cliente',
  'customerCategoryPartner': 'Parceiro',
  'customerCategoryMonitoring': 'Central',
  'customerStatus': 'Status',
  'customerStatusActive': 'Ativo',
  'customerStatusFrozen': 'Congelado',
  'customerStatusInactive': 'Inativo',
  'customerStatusTrial': 'Teste',
  'customerContact': 'Contato',
  'customerNotes': 'Notas',
  'customerDisabled': 'Desabilitado',
  'customerRegistrationDate': 'Data de Cadastro',
  'customerExpirationDate': 'Data de Expiração',
  'customerInvoiceDay': 'Dia de Cobrança',
  'customerAttributes': 'Atributos',

  'categoryArrow': 'Seta',
  'categoryAnimal': 'Animal',
  'categoryBicycle': 'Bicicleta',
  'categoryBoat': 'Barco',
  'categoryBus': 'Ônibus',
  'categoryCar': 'Carro',
  'categoryCrane': 'Guindaste',
  'categoryHelicopter': 'Helicóptero',
  'categoryMotorcycle': 'Motocicleta',
  'categoryOffroad': 'Offroad',
  'categoryPerson': 'Pessoa',
  'categoryPickup': 'Pick-up',
  'categoryPlane': 'Avião',
  'categoryShip': 'Navio',
  'categoryTractor': 'Trator',
  'categoryTrain': 'Trem',
  'categoryTram': 'Bonde',
  'categoryTrolleybus': 'Ônibus Elétrico',
  'categoryTruck': 'Caminhão',
  'categoryVan': 'Van',
  'categoryDefault': 'Padrão',
  'categoryDrone': 'Drone',
  'category_20ft_container': 'Container de 20 pés',
  'category_40ft_container': 'Container de 40 pés',
  'category_airliner': 'Avião de passageiros',
  'category_ambulance': 'Ambulância',
  'category_backhoe_loader': 'Retroescavadora',
  'category_bicycle': 'Bicicleta',
  'category_box_trailer': 'Reboque de Caixa',
  'category_bulldozer': 'Escavadeira',
  'category_bus': 'Ônibus',
  'category_cabriolet': 'Cabriolé',
  'category_camper_van': 'Van de Campista',
  'category_car': 'Carro',
  'category_car_trailer': 'Reboque de Carro',
  'category_caravan': 'Caravana',
  'category_concrete_pump': 'Caminhão Bomba de Concreto',
  'category_containerized_generator_trailer': 'Reboque de Gerador Container',
  'category_cruiser_motorcycle': 'Motocicleta cruzadora',
  'category_excavator': 'Escavadora',
  'category_executive_car': 'Carro Executivo',
  'category_farm_tractor': 'Trator Agrícola',
  'category_fire_truck': 'Caminhão de Bombeiros',
  'category_flatbed_trailer_bulkhead': 'Plataforma de Reboque de Mesa',
  'category_forklift_truck': 'Empilhadeira',
  'category_fuel_tank_truck': 'Caminhão Tanque de Combustível',
  'category_gully_emptier': 'Caminhão Vácuo',
  'category_hatchback': 'Carro Hatchback',
  'category_haul_truck': 'Caminhão de Transporte',
  'category_helicopter': 'Helicóptero',
  'category_luxury_car': 'Carro de Luxo',
  'category_mixer_truck': 'Caminhão Misturador (Betoneira)',
  'category_motorcycle': 'Motocicleta',
  'category_pedicab': 'Pedicab',
  'category_pickup': 'Pickup',
  'category_police': 'Viatura',
  'category_recovery_truck': 'Caminhão de Recuperação',
  'category_reefer_trailer': 'Reboque Reefer',
  'category_roadside_assistance_car': 'Carro de Assistência na Estrada',
  'category_van': 'Van',
  'category_sewer_cleaning_truck': 'Caminhão de Limpeza de Esgoto',
  'category_skip': 'Caixa Estacionária',
  'category_steamroller': 'Rolo Compressor',
  'category_swap_tank_container': 'Container de Tanque de Troca',
  'category_tanker_trailer': 'Reboque Tanque',
  'category_taxi': 'Táxi',
  'category_tow_rig': 'Pickup Reboque',
  'category_tow_truck': 'Caminhão Reboque',
  'category_tractor_flatbed_trailer': 'Caminhão Reboque Estrado',
  'category_tractor_trailer': 'Caminhão',
  'category_tractor_unit': 'Caminhão (Unidade Trator)',
  'category_truck': 'Caminhão Baú',
  'category_ultra_silent_generator_trailer': 'Reboque Gerador Ultra Silencioso',
  'category_waste_tanker_trailer': 'Reboque Tanque de Resíduos',
  'category_water_tank_truck': 'Caminhão Tanque de Água (Pipa)',
  'category_default': 'Padrão',
  'category_drone': 'Drone',
  'error_this_field': 'Este campo',
  'error_required_field': 'é obrigatório!',
  'error_invalid_type': 'Dados inválidos para tipo',
  'sharedInvalidNumber': 'Número inválido',
  'sharedDateInvalid': 'Data inválida',
  'sharedMinZero': 'deve ser maior ou igual a 0',

  'summaries': 'Resumos',
  'selectDevice': 'Selecionar dispositivo',
  'eventHistory': 'Histórico de Eventos',
  'routeHistory': 'Histórico de Rotas',
  'stopHistory': 'Histórico de Paradas',
  'tripHistory': 'Histórico de Viagens',
  'journeyHistory': 'Histórico de Percurso',
  'journeyLoadingRoute': 'Carregando rota...',
  'journeyTypeMovement': 'Movimento',
  'journeyTypeStopped': 'Parado',
  'journeyTripCount': 'Viagens',
  'journeyStopCount': 'Paradas',
  'journeyColStatus': 'Estado',
  'journeyColStart': 'Início',
  'journeyColEnd': 'Fim',
  'journeyColDuration': 'Duração',
  'journeyColEngine': 'Motor ligado',
  'journeyColDriver': 'Motorista',
  'journeyColEvents': 'Eventos',
  'journeyColDistance': 'Dist. ({unit})',
  'journeyColFuel': 'Combustível ({unit})',
  'journeyColStartLoc': 'Início Loc.',
  'journeyColEndLoc': 'Fim Loc.',

  'typeToSearch': 'Digite para pesquisar',
  'nothingFound': 'Nada encontrado!',

  'registeredDevices': 'Dispositivos Cadastrados',
  'devicesConnectionStatus': 'Status de Conexão dos Dispositivos',
  'lastCommunicationTime': 'Tempo da última comunicação',
  'connectionStatusByCategory': 'Status de conexão por categoria',
  'openCasualties': 'Sinistros abertos',

  'updatedAtFormat': '[Atualizado em] DD/MM/YY [às] HH:mm',

  'upToThirtyMin': 'Até 30 min',
  'upToFourHours': 'Até 4h',
  'upToTwentyFourHours': 'Até 24h',
  'moreThanTwentyFourHours': 'Mais que 24h',
  'never': 'Nunca',
  'upToFortyEightHours': 'Até 48h',
  'upToSeventyTwoHours': 'Até 72h',
  'moreThanSeventyTwoHours': '+ de 72h',

  'legendDeviceActive': 'Ativo',
  'legendDeviceInactive': 'Inativo',
  'legendDeviceOn': 'Ligado',

  'error_unknown': 'Erro desconhecido.',

  // react-dropzone
  [ErrorCode.FileInvalidType]: 'Somente as extensões {allowed_ext} são permitidas.',
  [ErrorCode.FileTooLarge]: 'Arquivo muito grande, o tamanho máximo permitido é de {max_allowed_size}.',
  [ErrorCode.FileTooSmall]: 'Arquivo muito pequeno, o tamanho mínimo permitido é de {min_allowed_size}.',
  [ErrorCode.TooManyFiles]: 'O máximo de arquivos enviados deve ser menor ou igual a {max_allowed_files}.',
  'companyLabel': 'Subdomínio',
  'companyCustomDomain': 'Domínio personalizado',
  'companyHideLoginFooter': 'Ocultar rodapé do login',
  'companyLogo': 'Logomarca',
  'companyAndroidAppUrl': 'URL do aplicativo Android',
  'companyIOSAppUrl': 'URL do aplicativo iOS',
  'companyTheme': 'Cor',
  'companyCustomerAreaLink': 'Link da área do cliente',
  'companyCustomerAreaContact': 'Contato da área do cliente',
  'companyAssistanceService': 'Serviço de assistência',
  'companyMonitoringCenterService': 'Serviço de central de monitoramento',
  'companyMonitoringCenterContact': 'Contato da central de monitoramento',
  'companyComplete': 'Completo',
  'companyMissing': 'Falta',
  'companyNothingToRemove': 'Esta central ainda não tem configuração para remover.',
  'label': 'Etiqueta',
  'labels': 'Etiquetas',
  'deviceRemoveConfirm': 'Você está removendo o dispositivo <strong><field>name</field></strong>! <br/>Realmente deseja fazer isso?',
  'savedCommandRemoveConfirm': 'Você está removendo o comando <strong><field>description</field></strong>! <br/>Realmente deseja fazer isso?',
  'commandBatchSentSuccess': 'Comandos enviados para execução com sucesso!',
  'commandBatchCheckAndRetry': 'Ops! Verifique os campos e tente novamente.',
  'commandBatchChooseDevices': 'Escolha dispositivo(s)',
  'commandBatchChooseGroups': 'Escolha grupo(s)',
  'commandBatchChooseCommand': 'Escolha o comando',
  'commandBatchExecute': 'Executar',
  'loginAppStoreAlt': 'Disponível na App Store',
  'loginGooglePlayAlt': 'Disponível no Google Play',
  'loginVersion': 'Versão 2.0',
  'userRemoveConfirm': 'Você está removendo o usuário <strong><field>name</field></strong>! <br/>Realmente deseja fazer isso?',
  'customerTypePF': 'Pessoa Física',
  'customerTypePJ': 'Pessoa Jurídica',
  'sharedAddressNumber': 'Número',
  'personalDeviceLastUpdate': 'Última atualização',
  'personalShowAllDevices': 'Mostrar todos os dispositivos',
  'personalDeviceInfo': 'Informações do Dispositivo',
  'userPaymentHolder': 'Titular',
  'userPaymentDependent': 'Dependente',
  'customerRemoveConfirm': 'Você está removendo o cliente <strong><field>name</field></strong>! <br/>Realmente deseja fazer isso?',
  'geofenceRemoveConfirm': 'Você está removendo a cerca <strong><field>name</field></strong>! <br/>Realmente deseja fazer isso?',
  'groupRemoveConfirm': 'Você está removendo o grupo <strong><field>name</field></strong>! <br/>Realmente deseja fazer isso?',
  'driverRemoveConfirm': 'Você está removendo o motorista <strong><field>name</field></strong>! <br/>Realmente deseja fazer isso?',
  'customerRegistrationSection': 'Situação Cadastral',
  'geofencePolygon': 'Polígono',
  'maintenanceRemoveConfirm': 'Você está removendo a configuração <strong><field>name</field></strong>! <br/>Realmente deseja fazer isso?',
  'notificationRemoveConfirm': 'Você está removendo a notificação <strong><field>title</field></strong>! <br/>Realmente deseja fazer isso?',
  'calendarRemoveConfirm': 'Você está removendo o calendário <strong><field>name</field></strong>! <br/>Realmente deseja fazer isso?',
  'adminChartLastCommunication': 'Última Comunicação',
  'adminChartConnectionStatus': 'Status de Conexão',
  'adminChartDeviceConnection': 'Conexão dos Dispositivos',
  'adminChartChooseType': 'Escolha um tipo',
  'adminChartChooseStatus': 'Escolha um status',
  'adminChartDeviceIncidents': 'Sinistro dos Dispositivos',
  'adminChartFilterDevices': 'Filtre por dispositivos',
  'adminChartServerDate': 'Data do servidor',
  'adminChartDeviceDate': 'Data do dispositivo',
  'adminChartGpsDate': 'Data do GPS',
  'adminEventsFilter': 'Filtrar Eventos',
  'unitNauticalMiles': 'Milhas Náuticas',
  'unitImpGallon': 'Imp. Galão',
  'unitUsGallon': 'U.S. Galão',

  // Date/time format strings passed directly to moment().format()
  'dateTimeLongFormat': 'DD/MM/YYYY [-] HH:mm:ss',
  'shortDateFormat': 'DD/MM/YY',
  'dateFormat': 'DD/MM/YYYY',
  'sinisterOpeningDateFormat': 'DD/MM/YYYY [-] HH:mm',
  // Billing block (delinquency)
  'billingBlockTab': 'Suspensão e bloqueios',
  'billingBlockSubtabSettings': 'Configuração',
  'billingBlockSubtabBlocks': 'Bloqueados',
  'billingBlockSubtabExemptions': 'Isenções de bloqueio',
  'billingBlockSubtabReport': 'Relatório de bloqueios',
  'billingBlockRefresh': 'Atualizar',
  'billingBlockRetry': 'Tentar de novo',
  'billingBlockCancel': 'Cancelar',
  'billingBlockLoading': 'Carregando…',
  'billingBlockInactiveCentral': 'Sua central está sem acesso a esta área. Fale com o suporte da Azul.',
  'billingBlockDiscardTitle': 'Descartar alterações?',
  'billingBlockDiscardChanges': 'Há alterações não salvas na configuração. Se continuar, elas serão perdidas.',
  'billingBlockDiscardConfirm': 'Descartar alterações',
  'billingBlockErrorAlreadyReleased': 'Este bloqueio de dispositivo já foi liberado. A lista foi atualizada.',
  'billingBlockErrorCentralSuspended': 'A central está suspensa: não é possível liberar dispositivos nem desligar o bloqueio de dispositivos. Fale com o suporte da Azul.',
  'billingBlockErrorAlreadyExemptCustomer': 'Este cliente já está isento do bloqueio de dispositivos. A lista de isenções foi atualizada.',
  'billingBlockErrorAlreadyExemptDevice': 'Este dispositivo já está isento do bloqueio de dispositivos. A lista de isenções foi atualizada.',
  'billingBlockErrorOtherCentral': 'Este cliente ou dispositivo não pertence à sua central.',
  'billingBlockErrorNotFound': 'O item não foi encontrado e pode ter sido removido. A lista foi atualizada.',
  'billingBlockErrorForbidden': 'Seu usuário não tem permissão para alterar estes dados.',
  'billingBlockErrorInvalid': 'Confira os dados informados e tente de novo.',
  'billingBlockErrorConflict': 'Os dados mudaram enquanto a tela estava aberta. A lista foi atualizada.',
  'billingBlockErrorUnexpected': 'Não foi possível concluir a ação. Tente de novo em alguns instantes.',
  'billingBlockReleasedNotExempted': 'O dispositivo foi liberado, mas a isenção não foi criada. Crie a isenção na subaba Isenções de bloqueio.',
  'billingBlockStatusActive': 'Bloqueado',
  'billingBlockStatusReleased': 'Liberado',
  'billingBlockCommandStatusPending': 'Pendente',
  'billingBlockCommandStatusSent': 'Enviado',
  'billingBlockCommandStatusConfirmed': 'Confirmado',
  'billingBlockCommandStatusDiscarded': 'Descartado',
  'billingBlockCommandStatusNotSupported': 'Rastreador sem suporte',
  'billingBlockReleaseReasonPayment': 'Pagamento',
  'billingBlockReleaseReasonCancelled': 'Cancelamento',
  'billingBlockReleaseReasonManual': 'Liberação manual',
  'billingBlockReleaseReasonOptionDisabled': 'Opção desligada',
  'billingBlockReleaseReasonCustomerChanged': 'Dispositivo mudou de cliente',
  'billingBlockReleaseReasonExemption': 'Isenção',
  'billingBlockReleaseCommandStatusSent': 'Enviado',
  'billingBlockReleaseCommandStatusConfirmed': 'Confirmado',
  'billingBlockReleaseCommandStatusNoConfirmation': 'Sem confirmação',
  'billingBlockDispatchTypeBlockCommand': 'Bloqueio',
  'billingBlockDispatchTypeReleaseCommand': 'Liberação',
  'billingBlockDispatchResultSent': 'Enviado',
  'billingBlockDispatchResultConfirmed': 'Confirmado',
  'billingBlockDispatchResultUnconfirmed': 'Não confirmado',
  'billingBlockDispatchResultNoConfirmation': 'Sem confirmação',
  'billingBlockDispatchResultPending': 'Pendente',
  'billingBlockDispatchResultDiscarded': 'Descartado',
  'billingBlockDispatchResultNotSupported': 'Rastreador sem suporte',
  'billingBlockDispatchResultFailed': 'Falhou',
  'billingBlockRunStatusRunning': 'Em execução',
  'billingBlockRunStatusCompleted': 'Concluída',
  'billingBlockRunStatusFailed': 'Falhou',
  'billingBlockRunStatusMissed': 'Não executou',
  'billingBlockSettingsTitle': 'Suspensão de clientes e bloqueio de dispositivos',
  'billingBlockGraceDays': 'Carência (dias)',
  'billingBlockGraceDaysDefault': 'padrão: {days} dias',
  'billingBlockGraceDaysHelp': 'A carência vale para a suspensão do acesso dos clientes e dos seus usuários e para o bloqueio de dispositivos. Mudar a carência não revisa bloqueios já aplicados.',
  'billingBlockGraceDaysInvalid': 'Informe um número inteiro de 0 a 60 ou deixe vazio para usar o padrão.',
  'billingBlockBlockDevices': 'Bloquear dispositivos de clientes inadimplentes',
  'billingBlockSave': 'Salvar',
  'billingBlockSettingsSaved': 'Configuração salva.',
  'billingBlockEnableTitle': 'Ligar o bloqueio de dispositivos?',
  'billingBlockEnableBody': 'A partir da próxima rotina diária, os dispositivos de clientes com cobrança vencida há mais de {days} dias recebem o comando de bloqueio quando estiverem parados.',
  'billingBlockEnableAccept': 'Li e aceito o termo de responsabilidade.',
  'billingBlockEnableConfirm': 'Ligar bloqueio de dispositivos',
  'billingBlockResponsibilityTerm': 'Ao ligar o bloqueio de dispositivos, a central declara que:\n1. Tem contrato com cada cliente que autoriza, de forma expressa e em destaque, o envio do comando de bloqueio ao dispositivo em caso de inadimplência, e informou o cliente dessa consequência antes da contratação (Código de Defesa do Consumidor, arts. 6º, III, 46 e 54, § 4º). Sem essa autorização, o bloqueio pode configurar exercício arbitrário das próprias razões (Código Penal, art. 345).\n2. Avisa o cliente da cobrança vencida e da data a partir da qual o dispositivo pode ser bloqueado, antes de terminar a carência.\n3. Não usa o bloqueio para expor o cliente a ridículo, constrangimento ou ameaça, nem para interferir no trabalho, no descanso ou no lazer dele além do que o contrato prevê (CDC, arts. 42 e 71).\n4. Isenta os clientes e os dispositivos cujo bloqueio possa pôr em risco a vida, a saúde ou a segurança de pessoas, como os instalados em ambulâncias e viaturas de socorro (CDC, art. 6º, I). O comando só é enviado com o dispositivo parado, o que não elimina esse risco.\n5. Libera o dispositivo quando a cobrança é paga, cancelada ou renegociada, e acompanha as liberações sem confirmação no Relatório de bloqueios (CDC, art. 51, XVIII).\n6. Mantém corretos os dados das cobranças na integração com o Asaas e responde pelos danos causados por um bloqueio indevido (Código Civil, arts. 186, 187 e 927).\n7. Usa a localização e o estado dos dispositivos só para executar o contrato com o cliente e proteger o crédito (Lei Geral de Proteção de Dados, art. 7º, V e X).',
  'billingBlockDisableTitle': 'Desligar o bloqueio de dispositivos?',
  'billingBlockDisableBody': 'Todos os dispositivos bloqueados por inadimplência dos seus clientes serão liberados agora. A suspensão do acesso dos clientes não muda.',
  'billingBlockDisableConfirm': 'Desligar bloqueio de dispositivos',
  'billingBlockColumnCustomer': 'Cliente',
  'billingBlockColumnDevice': 'Dispositivo',
  'billingBlockColumnChargeValue': 'Valor',
  'billingBlockColumnChargeDueDate': 'Vencimento',
  'billingBlockColumnStatus': 'Situação',
  'billingBlockColumnCommandStatus': 'Comando',
  'billingBlockColumnBlockedAt': 'Bloqueado em',
  'billingBlockColumnReleaseReason': 'Motivo da liberação',
  'billingBlockColumnActions': 'Ações',
  'billingBlockDetails': 'Detalhes',
  'billingBlockDetailsTitle': 'Bloqueio do dispositivo {device}',
  'billingBlockClose': 'Fechar',
  'billingBlockDetailCommandSentAt': 'Comando enviado em',
  'billingBlockDetailReleasedAt': 'Liberado em',
  'billingBlockDetailReleaseNote': 'Observação',
  'billingBlockDetailReleaseCommandStatus': 'Comando de liberação',
  'billingBlockFilterStatus': 'Situação',
  'billingBlockFilterActive': 'Bloqueados',
  'billingBlockFilterReleased': 'Liberados',
  'billingBlockFilterAll': 'Todos',
  'billingBlockClearFilters': 'Limpar filtro',
  'billingBlockSearchPlaceholder': 'Digite para buscar',
  'billingBlockSearchNoResults': 'Nenhum resultado',
  'billingBlockSearchClear': 'Limpar {field}',
  'billingBlockRelease': 'Liberar',
  'billingBlockReleaseTitle': 'Liberar dispositivo',
  'billingBlockReleaseBody': 'O dispositivo {device} recebe o comando de liberação. A liberação vale só para esta cobrança: se outra cobrança vencer, ele volta a ser bloqueado.',
  'billingBlockReleaseNote': 'Motivo da liberação',
  'billingBlockReleaseNoteRequired': 'Informe o motivo da liberação.',
  'billingBlockReleased': 'Dispositivo liberado.',
  'billingBlockReleaseAndExempt': 'Liberar e isentar',
  'billingBlockReleaseAndExemptBody': 'O dispositivo {device} é liberado e, em seguida, {target} fica isento de novos bloqueios de dispositivo.',
  'billingBlockExemptTargetDevice': 'o dispositivo',
  'billingBlockExemptTargetCustomer': 'o cliente',
  'billingBlockExemptTargetLabel': 'O que isentar',
  'billingBlockExemptTargetDeviceOption': 'Só este dispositivo',
  'billingBlockExemptTargetDeviceHelp': 'Libera {device} e impede novos bloqueios dele.',
  'billingBlockExemptTargetCustomerOption': 'Todos os dispositivos do cliente',
  'billingBlockExemptTargetCustomerHelp': 'Libera {count, plural, one {# dispositivo bloqueado} other {# dispositivos bloqueados}} de {customer} e impede novos bloqueios de qualquer dispositivo dele.',
  'billingBlockExemptTargetCustomerHelpPending': 'Libera os dispositivos bloqueados de {customer} e impede novos bloqueios de qualquer dispositivo dele.',
  'billingBlockReleaseAllPartial': '{released} de {total} dispositivos foram liberados. A isenção do cliente não foi criada porque algum dispositivo não foi liberado. Tente de novo.',
  'billingBlockReleasedAndExempted': 'Dispositivo liberado e isenção criada.',
  'billingBlockEmptyActive': 'Nenhum dispositivo está bloqueado agora.',
  'billingBlockShowReleased': 'Ver liberados',
  'billingBlockEmptyBlocks': 'Nenhum bloqueio de dispositivo foi registrado.',
  'billingBlockEmptyFiltered': 'Nenhum bloqueio atende ao filtro escolhido.',
  'billingBlockNewExemption': 'Nova isenção',
  'billingBlockExemptionKind': 'Isentar',
  'billingBlockKindCustomer': 'Cliente',
  'billingBlockKindDevice': 'Dispositivo',
  'billingBlockExemptionNote': 'Observação (opcional)',
  'billingBlockExemptionWarning': 'A isenção impede novos bloqueios de dispositivo, mas não destrava um dispositivo já bloqueado. Para destravar, libere o bloqueio antes de isentar. A isenção vale só para o bloqueio de dispositivos.',
  'billingBlockExemptionCustomerExempt': 'O cliente {customer} já está isento. A isenção do dispositivo continua valendo mesmo se a do cliente for desfeita.',
  'billingBlockExemptionTargetRequired': 'Escolha o cliente ou o dispositivo.',
  'billingBlockExempt': 'Isentar',
  'billingBlockExemptionCreated': 'Isenção criada.',
  'billingBlockColumnTarget': 'Cliente ou dispositivo',
  'billingBlockColumnKind': 'Tipo',
  'billingBlockColumnNote': 'Observação',
  'billingBlockColumnCreatedAt': 'Criada em',
  'billingBlockRemoveExemption': 'Desfazer isenção',
  'billingBlockRemoveExemptionTitle': 'Desfazer isenção?',
  'billingBlockRemoveExemptionBodyCustomer': 'Os dispositivos do cliente voltam a poder ser bloqueados a partir da próxima rotina diária.',
  'billingBlockRemoveExemptionBodyDevice': 'O dispositivo volta a poder ser bloqueado a partir da próxima rotina diária.',
  'billingBlockExemptionRemoved': 'Isenção desfeita.',
  'billingBlockEmptyExemptions': 'Nenhum cliente ou dispositivo está isento do bloqueio.',
  'billingBlockPeriodFrom': 'De',
  'billingBlockPeriodTo': 'Até',
  'billingBlockApplyPeriod': 'Aplicar',
  'billingBlockPeriodRequired': 'Informe as duas datas.',
  'billingBlockPeriodInverted': 'A data final precisa ser igual ou posterior à inicial.',
  'billingBlockPeriodTooLong': 'O período pode ter no máximo 30 dias.',
  'billingBlockColumnStartedAt': 'Início',
  'billingBlockColumnFinishedAt': 'Fim',
  'billingBlockColumnDispatchCount': 'Envios',
  'billingBlockOpenRun': 'Ver envios',
  'billingBlockBackToRuns': 'Voltar às execuções',
  'billingBlockRunTitle': 'Envios da execução de {date}',
  'billingBlockColumnCharge': 'Cobrança',
  'billingBlockColumnType': 'Tipo',
  'billingBlockColumnResult': 'Resultado',
  'billingBlockColumnTime': 'Horário',
  'billingBlockColumnDetail': 'Detalhe',
  'billingBlockEmptyRuns': 'Nenhuma execução da rotina neste período.',
  'billingBlockEmptyRunsAtAll': 'A rotina ainda não foi executada.',
  'billingBlockResetPeriod': 'Ver o dia da execução mais recente',
  'billingBlockEmptyDispatches': 'Nesta execução não houve envios para os dispositivos dos seus clientes.',
};
